import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import type { IImage } from 'tbk-components/src/components/Image';
import Icon from 'tbk-components/src/components/Icon';

export interface IPrettyPDF {
	label?: string;
	/**
	 * PrettyPDF link
	 */
	pdfLink?: IImage;
	fileSize?: string;
}

export interface IPrettyPDFProps extends IBaseElementProps {
	prettyPDFS: IPrettyPDF[];
}

/**
 * Displays a list of PDF links
 * @block
 * @icon pdf
 */
const PrettyPDF: React.FC<IPrettyPDFProps> = ({
	className,
	classNames = [],
	prettyPDFS = [],
}) => (
	<div
		className={
			className || cn('pretty-pdf', 'container-fluid', ...classNames)
		}
	>
		<div
			className={cn(
				'pretty-pdf__wrapper',
				(prettyPDFS.length == 1) && 'pretty-pdf__wrapper--single',
				(prettyPDFS.length == 2) && 'pretty-pdf__wrapper--double',
				(prettyPDFS.length == 3) && 'pretty-pdf__wrapper--treble',
			)}
		>
			{prettyPDFS.length > 0 &&
				prettyPDFS.map(
					({ pdfLink, fileSize, label }, index) =>
						pdfLink && (
							<a
								key={index}
								href={pdfLink.src}
								target="_blank"
								className="pretty-pdf-item"
								rel="noreferrer"
							>
								{label && (
									<h3 className="pretty-pdf-item__label">
										{label}
									</h3>
								)}
								{fileSize && (
									<span className="pretty-pdf-item__caption">
										{fileSize}
									</span>
								)}
								<span className="pretty-pdf-item__icon">
									<Icon name="download" />
								</span>
							</a>
						),
				)}
		</div>
	</div>
);

export default PrettyPDF;
